import { TagsResponseType } from '@ukpostbox/client-data/lib/Types/Response/TagsResponseTypes';
import { SelectItemType } from '@ukpostbox/frontend-framework';

const ShapeTagSelectData = (tagData: any): Array<SelectItemType> => {
	const selectOptions: Array<SelectItemType> = [];

	if (!tagData) return selectOptions;

	tagData.pages.map((page: TagsResponseType) =>
		page.data.map((tag) => selectOptions.push({ label: tag.name, value: tag.id })),
	);

	return selectOptions;
};

export { ShapeTagSelectData };
